import { gql } from '@apollo/client';
import {
  LibraryBrandEntertainmentFragment,
  LibraryBrandEntertainmentMinifiedFragment,
} from './libraryBrandEntertainment';
import {
  ILibraryCategoryEntertainment,
  LibraryCategoryEntertainmentFragment,
} from './libraryCategoryEntertainment';
import { LibraryOpeningHoursFragment } from './libraryOpeningHours';
import { LibraryOpeningHoursExceptionsFragment } from './libraryOpeningHoursException';
import { LibrarySocialMediaLinksFragment } from './librarySocialMediaLinks';
import { TTenantTypes } from './meetingPlacePageTenantList';
import { ICircularServicesTags } from './meetingPlacePageTenantShopItem';
import {
  LibraryBrandShopFragment,
  LibraryBrandShopMinifiedFragment,
} from './libraryBrandShop';
import {
  LibraryBrandFoodBeverageFragment,
  LibraryBrandFoodBeverageMinifiedFragment,
} from './libraryBrandFoodBeverage';

export interface IMeetingPlacePageTenantEntertainmentItem {
  __typename: string;
  sys: {
    id: string;
    locale: string;
  };
  brand: any;
  name: string;
  slug: string;
  unitId?: string[];
  floorPlanIDs: string[];
  logo: any;
  description: any;
  contactDetails: any;
  coverImage: any;
  primaryCategory: any;
  secondaryCategoriesCollection: {
    items: ILibraryCategoryEntertainment[];
  };
  openingHours: any;
  openingHoursExceptionsCollection: { items: any[] };
  socialMediaLinks: any;
  customizedSlug: string;
  // node_locale: string;
  seoDescription: any;
  giftCard: boolean;
  loyaltyCard: boolean;
  isItAMultiBrandStore?: string;
  subShopsListTitle?: string;
  subShopItemCollection: {
    items: TTenantTypes[];
  };
  hasOffer?: boolean;
  hasEvent?: boolean;
  offerCampaignNames?: string[];
  circularServicesCollection: { items: ICircularServicesTags[] };
}

export const MeetingPlacePageTenantEntertainmentItemFragment = gql`
  ${LibraryBrandEntertainmentFragment}
  ${LibraryBrandShopFragment}
  ${LibraryBrandFoodBeverageFragment}
  ${LibraryCategoryEntertainmentFragment}
  ${LibraryOpeningHoursFragment}
  ${LibraryOpeningHoursExceptionsFragment}
  ${LibrarySocialMediaLinksFragment}
  fragment MeetingPlacePageTenantEntertainmentItem on MeetingPlacePageTenantEntertainment {
    __typename
    sys {
      id
      locale
    }
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShop
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverage
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainment
      }
    }
    name
    slug
    floorPlanIDs
    unitId
    coverImage {
      description
      url
      height
      width
    }
    logo {
      description
      url
      height
      width
    }
    description {
      json
    }
    contactDetails {
      json
    }
    primaryCategory {
      ...LibraryCategoryEntertainment
    }
    secondaryCategoriesCollection {
      items {
        ...LibraryCategoryEntertainment
      }
    }
    openingHours {
      ...LibraryOpeningHours
    }
    openingHoursExceptionsCollection {
      items {
        ... on LibraryOpeningHoursException {
          ...LibraryOpeningHoursExceptions
        }
      }
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
    seoDescription
    giftCard
    loyaltyCard
  }
`;

export const MeetingPlacePageTenantEntertainmentItemMinifiedFragment = gql`
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryCategoryEntertainmentFragment}
  fragment MeetingPlacePageTenantEntertainmentItemMinified on MeetingPlacePageTenantEntertainment {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    logo {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryEntertainment
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryEntertainment
      }
    }
  }
`;

export const MeetingPlacePageTenantEntertainmentItemMinifiedLogoFragment = gql`
  fragment MeetingPlacePageTenantEntertainmentItemMinifiedLogo on MeetingPlacePageTenantEntertainment {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }
`;

export const MeetingPlacePageTenantEntertainmentListItemFragment = gql`
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryCategoryEntertainmentFragment}
  fragment MeetingPlacePageTenantEntertainmentListItem on MeetingPlacePageTenantEntertainment {
    __typename
    sys {
      id
      locale
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryEntertainment
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryEntertainment
      }
    }
    giftCard
    loyaltyCard
  }
`;

